// @flow

import type {Action} from '../../types';
import type {DictionaryStorage} from '../types';

import {SET_PAYMENT_METHOD, SET_PROJECTS} from '../actions/dictionary';

const initialState: DictionaryStorage = {
  projects: [],
  paymentMethods: []
};

export default (state: DictionaryStorage = initialState, action: Action) => {
  switch (action.type) {
    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethods: action.payload
      };
    case SET_PROJECTS:
      return {
        ...state,
        projects: action.payload
      };
    default:
      return state;
  }
};
